import React from 'react';

import BaseStore from 'bz-stores/mobx/base-store';

import history from 'bz-utilities/modules/networking/history/rr4';

import EmailWarningDialogStore from 'dmarc/stores/dialog-store';

import { DMARCAcknowledgementRequest } from 'tm3-core/api.dtos';

export type TDialog = [EmailWarningDialogStore, () => void, () => void];

const useEmailWarningDialog = (path: string): TDialog => {
  React.useDebugValue('useEmailWarningDialog');

  const [dialogStore] = React.useState(() => {
    const store = new EmailWarningDialogStore();
    store.open();

    return store;
  });

  const onYes = React.useCallback(() => {
    history.push(path);
    dialogStore.close();
    if (dialogStore.checked) {
      BaseStore.defaultClient.post(new DMARCAcknowledgementRequest());
    }
  }, [dialogStore, path]);

  const onNo = React.useCallback(() => {
    dialogStore.close();
    if (dialogStore.checked) {
      BaseStore.defaultClient.post(new DMARCAcknowledgementRequest());
    } else {
      const cachedUserId = parseInt(localStorage.getItem('cache:userId') || '') || -1;
      const now = new Date();
      localStorage.setItem(`${cachedUserId}:dmarc-dismiss-timestamp`, now.toDateString());
    }
  }, [dialogStore, path]);

  return [dialogStore, onYes, onNo];
};

export default useEmailWarningDialog;
